// extracted by mini-css-extract-plugin
export default {"container":"Ussd_container__wGiha","main":"Ussd_main__eghEZ","body":"Ussd_body__U4IeS"};